import { STAGE_DISPLAY_LABELS } from 'utils/residentTerminology';
import { ROLE_DISPLAY_LABELS } from 'utils/entityTerminology';

export const USER_ROLE = ROLE_DISPLAY_LABELS;

export const APP_STAGE = {
  Stage00: '00 - Entrata',
  Stage01: '01 - Tenant Evaluation',
  Stage02: '02 - Document Verification and Onboarding',
  Stage02A: '02A - Final Review',
  Stage04: '04 - Agreement Signed',
  Stage05: '05 - Policy Issued',
  Stage06: '06 - Policy Declined',
  Cancelled: 'Cancelled Application',
};

export const APP_TYPE = {
  AE: 'Auto Enroll',
  RG: 'Rent Guaranty',
  LDR: 'LDR',
  LDRC: 'LDR Commercial',
};

export const INVOICE_OFF_ITEMS = [
  'Cancellation',
  'Different Amount',
  'Duplicate',
  'Claim Filed',
  'Other',
];

/** Application stage filter dropdowns ({ value, text }). */
export const APPLICATION_STAGE_FILTER_OPTIONS = [
  { value: '00 - Entrata', text: STAGE_DISPLAY_LABELS['00 - Entrata'] },
  { value: '01 - Tenant Evaluation', text: STAGE_DISPLAY_LABELS['01 - Tenant Evaluation'] },
  { value: '02A - Final Review', text: STAGE_DISPLAY_LABELS['02A - Final Review'] },
  {
    value: '02 - Document Verification and Onboarding',
    text: STAGE_DISPLAY_LABELS['02 - Document Verification and Onboarding'],
  },
  { value: '04 - Agreement Signed', text: STAGE_DISPLAY_LABELS['04 - Agreement Signed'] },
  { value: '05 - Policy Issued', text: STAGE_DISPLAY_LABELS['05 - Policy Issued'] },
  { value: '06 - Policy Declined', text: STAGE_DISPLAY_LABELS['06 - Policy Declined'] },
  { value: 'Cancelled Application', text: STAGE_DISPLAY_LABELS['Cancelled Application'] },
  { value: 'Duplicate Application', text: STAGE_DISPLAY_LABELS['Duplicate Application'] },
  { value: 'Policy Fully Refunded', text: STAGE_DISPLAY_LABELS['Policy Fully Refunded'] },
];

/** Application type filter dropdowns — empty string matches legacy blank app_type. */
export const APP_TYPE_FILTER_OPTIONS = [
  { text: 'Guarantor Waiver Program', value: '' },
  { text: 'Event Process', value: 'Event Process' },
  { text: 'LDR', value: 'LDR' },
  { text: 'LDR Commercial', value: 'LDR Commercial' },
  { text: 'Rent Guaranty', value: 'Rent Guaranty' },
];

/** Property > Applications list: three program types only. */
export const APPLICATION_LIST_APP_TYPE_FILTER_OPTIONS = [
  { text: 'Rent Guaranty', value: 'Rent Guaranty' },
  { text: 'Guarantor Waiver Program', value: 'Auto Enroll' },
  { text: 'LDR Commercial', value: 'LDR Commercial' },
];

/** Property > Claims list — same three program types as Applications. */
export const CLAIM_LIST_APP_TYPE_FILTER_OPTIONS = APPLICATION_LIST_APP_TYPE_FILTER_OPTIONS;

/** Property > Policies list filter — three program types plus Unknown (LLP-014). */
export const POLICY_LIST_APP_TYPE_FILTER_OPTIONS = [
  ...APPLICATION_LIST_APP_TYPE_FILTER_OPTIONS,
  { text: 'Unknown', value: '' },
];

/** Policy list Application Type column — user-facing program names. */
export const POLICY_LIST_APP_TYPE_TABLE_META = [
  { value: 'Auto Enroll', label: 'Guarantor Waiver Program', badge: 'purpleIrish' },
  { value: 'LDR Commercial', label: 'LDR Commercial', badge: 'magentaRed' },
  { value: 'Rent Guaranty', label: 'Rent Guaranty', badge: 'sunglow' },
];

/** Property > Applications list maps GWP label to Auto Enroll for BE filters. */
export const APP_TYPE_FILTER_OPTIONS_AUTO_ENROLL = APP_TYPE_FILTER_OPTIONS.map((option) =>
  option.text === 'Guarantor Waiver Program' ? { ...option, value: 'Auto Enroll' } : option,
);

/** Application table stage badges ({ value, label, badge? }). */
export const APPLICATION_STAGE_TABLE_META = [
  { value: '00 - Entrata', label: STAGE_DISPLAY_LABELS['00 - Entrata'], badge: 'neutral' },
  {
    value: '01 - Tenant Evaluation',
    label: STAGE_DISPLAY_LABELS['01 - Tenant Evaluation'],
    badge: 'purple',
  },
  {
    value: '02A - Final Review',
    label: STAGE_DISPLAY_LABELS['02A - Final Review'],
    badge: 'parisGreen',
  },
  {
    value: '02 - Document Verification and Onboarding',
    label: STAGE_DISPLAY_LABELS['02 - Document Verification and Onboarding'],
    badge: 'tomato',
  },
  {
    value: '04 - Agreement Signed',
    label: STAGE_DISPLAY_LABELS['04 - Agreement Signed'],
    badge: 'sunglow',
  },
  {
    value: '05 - Policy Issued',
    label: STAGE_DISPLAY_LABELS['05 - Policy Issued'],
    badge: 'purpleIrish',
  },
  { value: '06 - Policy Declined', label: STAGE_DISPLAY_LABELS['06 - Policy Declined'] },
  {
    value: 'Cancelled Application',
    label: STAGE_DISPLAY_LABELS['Cancelled Application'],
    badge: 'magentaRed',
  },
  {
    value: 'Duplicate Application',
    label: STAGE_DISPLAY_LABELS['Duplicate Application'],
    badge: 'warmBlue',
  },
  {
    value: 'Policy Fully Refunded',
    label: STAGE_DISPLAY_LABELS['Policy Fully Refunded'],
    badge: 'purple',
  },
];

/** Application table app-type badges — user-facing program names. */
export const APPLICATION_TYPE_TABLE_META = [
  { value: '', label: 'Unknown', badge: 'neutral' },
  { value: 'Auto Enroll', label: 'Guarantor Waiver Program', badge: 'purpleIrish' },
  { value: 'LDR Commercial', label: 'LDR Commercial', badge: 'magentaRed' },
  { value: 'Rent Guaranty', label: 'Rent Guaranty', badge: 'sunglow' },
  { value: 'LDR', label: 'LDR Commercial', badge: 'magentaRed' },
  { value: 'Event Process', label: 'Rent Guaranty', badge: 'sunglow' },
];

/** Claim table app-type badges — same full program names as Applications/Policies (LLP-126). */
export const CLAIM_APPLICATION_TYPE_TABLE_META = APPLICATION_TYPE_TABLE_META;

/** Claim file status filter dropdowns ({ value, text }). */
export const CLAIM_FILE_STATUS_FILTER_OPTIONS = [
  { value: '', text: 'N/A' },
  { value: 'Closed - Partial denial', text: 'Closed - Partial denial' },
  { value: 'Closed Claim - Duplicate', text: 'Closed Claim - Duplicate' },
  { value: 'Incident Only', text: 'Incident Only' },
  { value: 'Closed - Claim Paid', text: 'Closed - Claim Paid' },
  { value: 'Closed - Claim Denied', text: 'Closed - Claim Denied' },
  { value: 'Open Claim - Test Claim', text: 'Open Claim - Test Claim' },
  { value: 'Open - Pending Payment', text: 'Open - Pending Payment' },
  { value: 'Closed Claim - Inactive', text: 'Closed Claim - Inactive' },
  { value: 'Open - Pending Decision', text: 'Open - Pending Decision' },
  { value: 'Closed - Incident Only', text: 'Closed - Incident Only' },
];

/** Claim table file-status badges ({ value, badge }). */
export const CLAIM_FILE_STATUS_TABLE_BADGES = [
  { value: '', badge: 'Open' },
  { value: 'Closed - Partial denial', badge: 'Closed' },
  { value: 'Closed Claim - Duplicate', badge: 'Duplicated' },
  { value: 'Incident Only', badge: 'Incident Only' },
  { value: 'Closed - Claim Paid', badge: 'Paid' },
  { value: 'Closed - Claim Denied', badge: 'Denied' },
  { value: 'Open Claim - Test Claim', badge: 'Test' },
  { value: 'Open - Pending Payment', badge: 'Pending' },
  { value: 'Closed Claim - Inactive', badge: 'Inactive' },
  { value: 'Open - Pending Decision', badge: 'Pending' },
  { value: 'Closed - Incident Only', badge: 'Incident Only' },
];

/** Dashboard chart drilldown: open-bucket claim file statuses. */
export const CLAIM_FILE_STATUS_OPEN_PORTION = [
  'Incident Only',
  'Open Claim - Test Claim',
  'Open - Pending Payment',
  'Open - Pending Decision',
];

/** Dashboard chart drilldown: closed-bucket claim file statuses. */
export const CLAIM_FILE_STATUS_CLOSED_PORTION = [
  'Closed - Partial denial',
  'Closed Claim - Duplicate',
  'Closed - Claim Paid',
  'Closed - Claim Denied',
  'Closed - Incident Only',
  'Closed Claim - Inactive',
];

/** ClaimPaymentsChart “Other” slice (non–pending-payment open bucket). */
export const CLAIM_PAYMENTS_OTHER_STATUSES = [
  'Incident Only',
  'Open Claim - Test Claim',
  'Open - Pending Decision',
];

/** ClaimFileStatusChart API keys → filter/display labels. */
export const CLAIM_FILE_STATUS_CHART_LABELS = {
  open_test_claim: 'Open Claim - Test Claim',
  open_pending_decision: 'Open - Pending Decision',
  open_pending_payment: 'Open - Pending Payment',
  closed_denied: 'Closed - Claim Denied',
  closed_paid: 'Closed - Claim Paid',
  closed_incident_only: 'Closed - Incident Only',
  closed_partial_denial: 'Closed - Partial Denial',
  closed_duplicate: 'Closed Claim - Duplicate',
  closed_inactive: 'Closed Claim - Inactive',
  incident_only: 'Incident Only',
};

/** Flagged cancellation policy flag filter ({ text, value }). */
export const POLICY_FLAG_FILTER_OPTIONS = [
  { text: 'None', value: '' },
  { text: 'Green', value: 'green' },
  { text: 'Red', value: 'red' },
];

/** Flagged cancellation active/cancelled filter ({ text, value }). */
/** Policies list: coverage lifecycle for adoption / management tracking. */
export const POLICY_COVERAGE_STATUS_FILTER_OPTIONS = [
  { text: 'Active', value: 'active' },
  { text: 'Future', value: 'future' },
  { text: 'Expired', value: 'expired' },
];

export const POLICY_STATUS_FILTER_OPTIONS = [
  { text: 'Active', value: 'FALSE' },
  { text: 'Cancelled', value: 'TRUE' },
];

export const Month = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export { getDemoData } from '../../utils/helpers';
